import { render, staticRenderFns } from "./GrowerView.vue?vue&type=template&id=01d295d3&scoped=true&"
import script from "./GrowerView.vue?vue&type=script&lang=js&"
export * from "./GrowerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d295d3",
  null
  
)

export default component.exports